import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { User_user } from 'main/gql/user'

import { i18nKeyPrefix } from '../i18n'
import { Container } from './LanguageSelection.styles'
import Select from './Select'

const PRE = `${i18nKeyPrefix}-LANGUAGE-SELECTION`

interface IProps {
  user: User_user | null
}

function LanguageSelection(props: IProps) {
  const { user } = props

  const { t, i18n } = useTranslation(NAMESPACE)
  const { availableLocales } = useWhitelabel()

  const [preferredLanguage, setPreferredLanguage] = React.useState<string>(
    user?.preferredLanguage ?? i18n.resolvedLanguage ?? 'en',
  )

  const options = React.useMemo(() => {
    return [
      { label: t(`${PRE}-SPANISH`), value: 'es' },
      { label: t(`${PRE}-ENGLISH`), value: 'en' },
      { label: t(`${PRE}-HAITIAN-CREOLE`), value: 'ht' },
      { label: t(`${PRE}-VIETNAMESE`), value: 'vi' },
    ].filter(option => availableLocales.includes(option.value))
  }, [i18n.resolvedLanguage, availableLocales])

  React.useEffect(() => {
    if (preferredLanguage) i18n.changeLanguage(preferredLanguage)
  }, [preferredLanguage])

  return (
    <Container>
      <Select value={preferredLanguage} onChange={onChange}>
        {options.map(({ value, label }) => (
          <option key={value} value={value} label={label}>
            {label}
          </option>
        ))}
      </Select>
    </Container>
  )

  function onChange(value: string | null) {
    const timestamp = Date.now()
    const newLanguage = value ?? 'en'

    // Set the preferred language in localStorage
    setPreferredLanguage(newLanguage)

    // Set the locale cookie so other apps can read it
    document.cookie = `react_app_locale=${newLanguage}; path=/; max-age=31536000; SameSite=Lax; domain=${window.location.hostname}`
    document.cookie = `react_app_locale_last_write=${timestamp}; path=/; max-age=31536000; SameSite=Lax; domain=${window.location.hostname}`
  }
}

export default React.memo(LanguageSelection)
